export default (array, item) => (array.some((pml) => pml.key === item.key)
  ? array.find((pml) => pml.key === item.key).docCount
  : 0);
